import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import moment from 'moment';
import config from '../../../../../config';
import TableBuilder from '../../../../../shared/components/table/TableBuilder';
import CardPanel from '../../../../../shared/components/widgets/CardPanel';
import { getExportPrefix } from '../../../../../shared/components/table/functions';
import { history } from '../../../../../helpers';

function AmcReportTable({ amcAccountId, instanceId, selectedSeller, notify, user }) {
  const [loading, setLoading] = useState(false);
  const [apiEndPoint, setApiEndPoint] = useState(`${config.serverUrl}/accounts/amc/reports?instanceId=${instanceId}`);

  useEffect(() => {
    setApiEndPoint(`${config.serverUrl}/accounts/amc/reports?instanceId=${instanceId}`);
  }, [instanceId])


  const createReport = async (rowData) => {
    if (selectedSeller && selectedSeller.value) {
      setLoading(true);
      const createBody = {
        accountId: selectedSeller.value,
        amcAccountId,
        instanceId,
        specId: rowData.data.specId,
      }

      notify.show('primary', `Started process to create ${rowData.data.workflowId} for ${selectedSeller.value}`, 'Report create requested');
      const headerWithAuth = { ...config.jsonHeader, authorization: `JWT ${user.jwtToken}` };
      const requestOptions = {
        method: 'POST',
        headers: headerWithAuth,
        body: JSON.stringify(createBody),
      };

      await fetch(apiEndPoint, requestOptions)
        .then((createResults) => {
          if (createResults.status === 401) {
            history.push('/logout');
          }
          if (!createResults.ok) {
            notify.show('danger', 'Create API Error', createResults.statusText);
            throw Error(createResults.statusText);
          }
          return createResults.json();
        }).then((data) => {
          notify.show('success', `Create ${rowData.data.workflowId} for ${selectedSeller.value} complete`, JSON.stringify(data));
          setApiEndPoint(`${config.serverUrl}/accounts/amc/reports?instanceId=${instanceId}&refreshKey=${moment().format()}`);
        });

      setLoading(false);
    }
  };

  const columnDefs = [
    {
      field: 'amcReportConfigId_dynamic',
      headerName: 'ID',
      cellRenderer: (params) => {
        if ((params.data.amcReportConfigId || 0) === 0) {
          return <button type="button" className="btn-aggrid" style={{ height: '100%' }} onClick={() => createReport(params)}>Create Report</button>;
        }
        return params.data.amcReportConfigId;
      },
    },
    {
      field: 'accountId',
      headerName: 'Account ID',
    },
    {
      field: 'amcAccountId_dynamic',
      headerName: 'AMC Account ID',
      cellRenderer: (params) => {
        if ((params.data.amcAccountId || 0) === 0) {
          return 201;
        }
        return params.data.amcAccountId;
      },
    },
    {
      field: 'instanceId',
      headerName: 'Instance ID',
    },
    {
      field: 'workflowId',
      headerName: 'Workflow ID',
    },
    {
      field: 'specId',
      headerName: 'Spec Id',
    },
    {
      field: 'reportType',
      headerName: 'Type',
    },
    {
      field: 'status',
      headerName: 'Status',
    },
    {
      field: 'updateTs',
      headerName: 'Update TS',
    },
    {
      field: 'createTs',
      headerName: 'Create TS',
    },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    editable: false,
  };

  const tableConfig = {
    showDatePicker: false,
    showFooter: false,
    apiEndPoint,
  };

  const exportPrefix = getExportPrefix('amc-reports', selectedSeller, true);

  return (
    <Container className="todo-app">
      <Row>
        <CardPanel
          autorenewButton={false}
          closeButton={false}
          parentRefresh={loading}
        >
          <TableBuilder
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            apiEndPoint={tableConfig.apiEndPoint}
            showDatePicker={tableConfig.showDatePicker}
            showFooter={tableConfig.showFooter}
            exportPrefix={exportPrefix}
          />
        </CardPanel>
      </Row>
    </Container>
  );
}

export default AmcReportTable;
